import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import api from '../api/axios';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import '../styles/navbar.css';

const AppNavbar = () => {

  const location = useLocation();
  const hideNavbar = location.pathname === '/';
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  // ✅ Obtener usuario autenticado al montar el Navbar
  useEffect(() => {
    const token = Cookies.get('access_token');
    if (!token) return;

    api.get('/user')
      .then(res => {
        setRoles(res.data.roles || []);
        setPermissions(res.data.permissions || []);
      })
      .catch(() => {
        setRoles([]);
        setPermissions([]);
      });
  }, []);

  const handleLogout = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);

    Swal.fire({
      title: "Cerrando sesión",
      text: "Por favor espere…",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      await api.post("/logout");
    } finally {
      Cookies.remove("access_token");
      setRoles([]);
      setPermissions([]);
      Swal.close();
      navigate("/", { replace: true });
      setIsLoggingOut(false);
    }
  };


  if (hideNavbar) return null;

  const isAdmin = roles.includes('admin');
  const hasRole = (role) => roles.includes(role);
  const can = (perm) => permissions.includes(perm);


  return (
    <Navbar expand="lg" className="custom-navbar" style={{ backgroundColor: '#0F443A' }} variant="dark">
      <Container fluid>

        <Navbar.Brand
          as={NavLink}
          className="logo-container d-flex align-items-center justify-content-center">
            <img
              src={"/assets/Amco_logo.png"}
              alt="Logo"
              className="logo-image"
            />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar-nav" />

        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={NavLink} to="/home" className="text-white ms-3">
              Inicio
            </Nav.Link>

            {can('reports.view') && (
              <Nav.Link as={NavLink} to="/monitor" className="text-white ms-3">
                Monitoreo
              </Nav.Link>
            )}

            {(can('vehicles.view') || can('persons.view') || can('rates.view')) && (
              <NavDropdown
                title="Operación"
                id="operacion-dropdown"
                menuVariant="dark"
                className="ms-3"
              >
                {can('vehicles.view') && (
                  <NavDropdown.Item as={NavLink} to="/vehicles">
                    Vehículos
                  </NavDropdown.Item>
                )}

                {can('persons.view') && (
                  <NavDropdown.Item as={NavLink} to="/persons">
                    Personas
                  </NavDropdown.Item>
                )}

                {isAdmin && (
                  <NavDropdown.Item as={NavLink} to="/register-device">
                    Dispositivos
                  </NavDropdown.Item>
                )}

                {can('rates.create') && (
                  <NavDropdown.Item as={NavLink} to="/rates">
                    Decretos Tarifarios
                  </NavDropdown.Item>
                )}

              </NavDropdown>
            )}
            {hasRole('admin') && (
              <NavDropdown
                title="Administración"
                id="admin-dropdown"
                menuVariant="dark"
                className="ms-3"
              >
                {(hasRole('admin') || can('tenants.view')) && (
                  <NavDropdown.Item as={NavLink} to="/tenants">
                    Empresas
                  </NavDropdown.Item>
                )}

                {can('users.view') && (
                  <NavDropdown.Item as={NavLink} to="/users">
                    Usuarios
                  </NavDropdown.Item>
                )}

                {can('logs.view') && (
                  <NavDropdown.Item as={NavLink} to="/logs">
                    Historial de Actividades
                  </NavDropdown.Item>
                )}
              </NavDropdown>
            )}

            {hasRole('admin') && (
              <NavDropdown
                title="Configuración"
                id="config-dropdown"
                menuVariant="dark"
                className="ms-3"
              >
                {hasRole('admin') && (
                  <NavDropdown.Item as={NavLink} to="/holidays">
                    Días Festivos
                  </NavDropdown.Item>
                )}

                {hasRole('admin') && (
                  <NavDropdown.Item as={NavLink} to="/places_geo_ref">
                    Lugares
                  </NavDropdown.Item>
                )}

                {hasRole('admin') && (
                  <NavDropdown.Item as={NavLink} to="/system_settings">
                    Configuración
                  </NavDropdown.Item>
                )}
              </NavDropdown>
            )}

            <Nav.Link onClick={handleLogout} className="text-white ms-3" style={{ opacity: isLoggingOut ? 0.6 : 1, pointerEvents: isLoggingOut ? "none" : "auto" }}>
              Cerrar Sesión
            </Nav.Link>
          </Nav>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
